var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"settings-box"},[_c('div',{staticClass:"section-title d-flex align-items-center"},[_c('i',{staticClass:"far fa-user-lock pr-2"}),_vm._v(" "+_vm._s(_vm.$t('settings.access'))+" ")]),_c('RoleList')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }